const timezones = {
  RU: 'Europe/Moscow', //In Russia trains run on Moscow time
  FI: 'Europe/Helsinki',
};

export default timezones;
